export enum EnumStatus {
  Success     = 200,
  Unauthorize = 401,
  Forbidden   = 403,
  Error       = 500,
  ErrorSystem = 505,
}

export enum EnumHttp {
  Get,
  Put,
  Post,
  Delete,
  GetAuth,
  PutAuth,
  PostAuth,
  DeleteAuth
}

export enum EnumPermission {
  // const ADMIN_VIEW                            = "4415297e3af8c",
  OPERATION_LOG_VIEW                    = "OPERATION_LOG_VIEW",
  DOWNLOAD_LOG_VIEW                     = "DOWNLOAD_LOG_VIEW",
  CONTACT_US_VIEW                       = "CONTACT_US_VIEW",

  SAN_VIEW                              = "SAN_VIEW",
  SAN_ADD                               = "SAN_ADD",
  SAN_EDIT                              = "SAN_EDIT",
  SAN_DELETE                            = "SAN_DELETE",

  COMPANY_VIEW                          = "COMPANY_VIEW",
  COMPANY_ADD                           = "COMPANY_ADD",
  COMPANY_EDIT                          = "COMPANY_EDIT",
  COMPANY_EDIT_PASSWORD                 = "COMPANY_EDIT_PASSWORD",
  COMPANY_DELETE                        = "COMPANY_DELETE",

  INDUSTRY_VIEW                         = "INDUSTRY_VIEW",
  INDUSTRY_ADD                          = "INDUSTRY_ADD",
  INDUSTRY_EDIT                         = "INDUSTRY_EDIT",
  INDUSTRY_DELETE                       = "INDUSTRY_DELETE",
    
  ANNOUNCEMENT_VIEW                     = "ANNOUNCEMENT_VIEW",
  ANNOUNCEMENT_ADD                      = "ANNOUNCEMENT_ADD",
  ANNOUNCEMENT_EDIT                     = "ANNOUNCEMENT_EDIT",
  ANNOUNCEMENT_DELETE                   = "ANNOUNCEMENT_DELETE",

  FAQ_VIEW                              = "FAQ_VIEW",
  FAQ_ADD                               = "FAQ_ADD",
  FAQ_EDIT                              = "FAQ_EDIT",
  FAQ_DELETE                            = "FAQ_DELETE",

  ADMIN_VIEW                            = "ADMIN_VIEW",
  ADMIN_ADD                             = "ADMIN_ADD",
  ADMIN_EDIT                            = "ADMIN_EDIT",
  ADMIN_DELETE                          = "ADMIN_DELETE",
  ADMIN_EDIT_PASSWORD                   = "ADMIN_EDIT_PASSWORD",
  ADMIN_EDIT_AUTHORITY                  = "ADMIN_EDIT_AUTHORITY",

  ADMIN_AUTHORITY_VIEW                  = "ADMIN_AUTHORITY_VIEW",
  ADMIN_AUTHORITY_ADD                   = "ADMIN_AUTHORITY_ADD",
  ADMIN_AUTHORITY_EDIT                  = "ADMIN_AUTHORITY_EDIT",
  ADMIN_AUTHORITY_DELETE                = "ADMIN_AUTHORITY_DELETE",
}

export enum EnumUserType {
  SYSTEM,
  ADMIN,
  COMPANY
}

export enum EnumLogActionType {
  LOGIN,
  CREATE,
  UPDATE,
  DELETE
}

export enum EnumDownloadLogActionType {
  SINGLE,
  MULTI
}


export enum EnumStatusTaskForm {
  FAILED                = -4,
  PROCESSING_DELETION   = -3,
  PROCESSING_REMATCHING = -2,
  DELETED               = -1,
  NEW                   = 0,
  PENDING_REMATCHION    = 1,
  SUCCESS               = 2
}